import { render } from "./InvoiceAllocations.vue?vue&type=template&id=0ecf1071&scoped=true"
import script from "./InvoiceAllocations.vue?vue&type=script&lang=js"
export * from "./InvoiceAllocations.vue?vue&type=script&lang=js"

import "./InvoiceAllocations.vue?vue&type=style&index=0&id=0ecf1071&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-0ecf1071"

export default script